import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";
import { showError, showSuccess } from "../../helpers/toaster";
import { constructQueryString } from "../../helpers/Functions";

const api = new APICore();

export const connectInstagram = createAsyncThunk(
  "instagram/connectInstagram",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CONNECT_INSTAGRAM, data);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const createInstagramPost = createAsyncThunk(
  "instagram/createInstagramPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CREATE_INSRAGRAM_POST, data);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);
export const createInstagramStory = createAsyncThunk(
  "instagram/createInstagramStory",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CREATE_INSRAGRAM_STORY, data);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const updateInstagramPost = createAsyncThunk(
  "instagram/updateInstagramPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.UPDATE_INSRAGRAM_POST, data);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getInstagramPost = createAsyncThunk(
  "instagram/getInstagramPost",
  async (data, { rejectWithValue }) => {
    console.log({ data });
    try {
      const query = constructQueryString(data);
      const response = await api.get(`${Url.GET_INSRAGRAM_POST}?${query}`);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getInstagramPostDetails = createAsyncThunk(
  "instagram/getInstagramPostDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${Url.GET_INSRAGRAM_POST_DETAILS}?postId=${data.postId}`
      );
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const deletePost = createAsyncThunk(
  "instagram/deletePost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `${Url.DELETE_INSRAGRAM_POST}?postId=${data.postId}`
      );
      // showSuccess(response.data.message);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);
